<template>
    <Sidebar 
        ref="sidebargestorclaves"
        v-model:visible="visiblesidegestorclaves"
        header="Gestor de claves de compañías para integración" 
        position="top" 
        @mouseleave="ocultarSidebar"
        style="height: 40rem; width: 90%; overflow-y: auto;"
    >
        <div class="container-fluid">
            <section class="content-header">
                <div class="row mb-2">
                    <h3>{{ $t('general.listadocompanias') }}</h3>
                </div>
            </section>
            <section class="content">
                <div class="row">
                    <div class="col-md-10">
                        <tabla-datos 
                            :columnas="columnasConAccion" 
                            :datos="companias" 
                            :filtros="filtros" 
                            :total="total" 
                            :botoncrear=1
                            :filtrosBuscador="filtrosBuscador" 
                            @quieroDatos="obtenerCompanias($event); mievento = $event;"/>
                    </div>
                </div>
            </section>

            <!-- MODAL -->
            <Dialog v-model:visible="modalVisible" header="Gestionar Clave" :modal="true" style="width: 30rem;">
                <span class="text-muted mt-4 mb-4">{{ companiaDetalle.nombre }}</span>
                <div class="p-fluid">

                    <div v-for="campo in camposFormulario" :key="campo.nombre" class="field mb-3">
                        <label :title="campo.descripcion">{{ campo.etiqueta }}</label>

                        <div v-if="campo.tipo === 'clave'" class="p-inputgroup">
                            <InputText 
                                type="text" 
                                v-model="companiaDetalle[campo.nombre]" 
                                autocomplete="off"
                                :name="'campo-' + campo.nombre"
                                :class="{ 'fake-password': !clavesVisibles[campo.nombre] }"
                            />
                            <Button 
                                :icon="clavesVisibles[campo.nombre] ? 'fas fa-eye-slash' : 'fas fa-eye'" 
                                @click="toggleVerClave(campo.nombre)" 
                                class="p-button-secondary"
                            />
                        </div>

                        <InputText 
                            v-else 
                            v-model="companiaDetalle[campo.nombre]" 
                            disabled
                        />
                    </div>

                    <!-- Fecha última actualización -->
                    <div class="field mb-3">
                        <label>Última actualización</label>
                        <p>{{ fechaActualizacionFormateada }}</p>
                    </div>

                    <!-- Estado conexión (placeholder, a definir lógica luego) -->
                    <div class="field mb-3">
                        <label>Estado conexión</label>
                        <div>
                            <i class="fas fa-circle" :class="estadoConexionClass" :title="estadoConexionTexto"></i>
                            &nbsp;{{ estadoConexionTexto }}
                        </div>
                    </div>

                </div>

                <template #footer>
                    <Button label="Cancelar" class="p-button-text" @click="modalVisible = false" />
                    <Button label="Guardar" @click="confirmarCambioClave" />
                </template>
            </Dialog>

        </div>
    </Sidebar>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { PwgsApi } from '../../../services/PwgsApi.js';
import TablaDatos from '../../TablaDatos.vue';
import Sidebar from 'primevue/sidebar';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

export default {
    name: "contrasenias",
    components: {
        TablaDatos,
        Sidebar,
        Dialog,
        InputText,
        Button
    },
    props: ['visiblegestorclaves'],
    data() {
        return {
            companias: [],
            filtrosBuscador: ['nombre'],
            total: '',
            modalVisible: false,
            companiaSeleccionadaId: null, 
            visiblesidegestorclaves: false,
            filtroSistemas: ['AMA', 'AXA_WS', 'FUNCIONA', 'GENERALI', 'LDWEB', 'MAPFRE', 'MULTIASISTENCIA_WS', 'MUTUA', 'PELAYO', 'REALE', 'REPARALIA', 'SANTALUCIA', 'SH24_BMP', 'VERYFICA'], 
            filtros: {
                'nombre': { value: "", matchMode: FilterMatchMode.CONTAINS},
            },
            columnas: [
                {
                    header: 'Nombre Compañía',
                    field: 'nombre',
                    sortable: true
                },
                {
                    header: 'Prefijo',
                    field: 'prefijo',
                    sortable: true
                },
                {
                    header: 'Nombre Sistema',
                    field: 'sistema_compannia',
                    sortable: true
                }
            ],
            companiaDetalle: {}, //datos cargados al abrir el modal
            companiaDetalleOriginal: {},
            estadoConexion: null,
            clavesVisibles: {},
            sistemasPorNombre: {}
        }
    },
    methods: {
        componenteDinamico(ruta) {
            return defineAsyncComponent(() => import(`@/${ruta}`));
        },

        async obtenerCompanias(event) {
            const api = new PwgsApi();
            // Crear una copia profunda de `event`
            let evaux = event ? JSON.parse(JSON.stringify(event)) : { filters: {} };

            if (evaux.filters) {
                for (let ev of Object.entries(evaux.filters)) {
                    if (ev[1].value === '') delete evaux.filters[ev[0]];
                }
            } else {
                evaux.filters = {};
            }

            evaux.rows= 200; // Traer todos los registros para filtrar en el front (a falta de filtro en el back)
            evaux.first = 0;

            //Obtener compañías y sistemas con su configuración de campos dinámicos
            const [companias, sistemas] = await Promise.all([
                api.get('/companias/simple?sortField=nombre&sortOrder=1', evaux),
                api.get('/sistemas', {})
            ]);

            const sistemasPorNombre = {};
            for (const s of sistemas.datos) {
                sistemasPorNombre[s.nombre] = s;
            }
            this.sistemasPorNombre = sistemasPorNombre;

            const datosFiltrados = companias.datos
                .filter( c => this.filtroSistemas.includes(c.sistema_compannia))
                .map(c => ({
                    ...c,
                    tipo_sistema: sistemasPorNombre[c.sistema_compannia]?.tipo ?? null
                }));
            
            this.companias = datosFiltrados;
            this.total = datosFiltrados.length;
        },
        ocultarSidebar() {
            if (!this.modalVisible) {
                this.visiblesidegestorclaves = false;
            }
        },
        async abrirModalCompania(id) {
            this.companiaSeleccionadaId = id;
            this.modalVisible = true;
            await this.cargarDetalleCompania(id);
        },

        async cargarDetalleCompania(id) {
            const api = new PwgsApi();
            const detalle = await api.get(`/companias/${id}`);
            this.companiaDetalle = detalle.datos;
            
            const companiaSeleccionada = this.companias.find(c => c.id === id);
            if (!companiaSeleccionada) {
                console.warn(`No se encontró la compañía con id=${id} en el listado de compañías. Verificar nombreId en columnasConAccion.`);
            }
            this.companiaDetalle.tipo_sistema = companiaSeleccionada?.tipo_sistema ?? null;
            
            this.companiaDetalleOriginal = { ...this.companiaDetalle }; // Guardar una copia 'original' para poder detectar cambios.
        },

        confirmarCambioClave() {
            const huboCambios = this.camposFormulario.some(campo => 
                campo.tipo === 'clave' &&
                this.companiaDetalle[campo.nombre] !== this.companiaDetalleOriginal[campo.nombre]
            );

            if(!huboCambios) {
                this.modalVisible = false;
                return;
            }

            this.$confirm.require({
                message: '¿Desea cambiar la contraseña? Compruebe que la contraseña ya está actualizada en la web de la compañía para no interrumpir la integración.',
                header: 'Confirmar cambio',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sí, cambiar',
                rejectLabel: 'Cancelar',
                accept: () => this.guardarClave(),
                reject: () => {}
            })
        },

        async guardarClave() {
            const api = new PwgsApi();

            const payload = {};

            //Arma el payload con los campos tipo 'clave' (dinámicos según compañía) y fecha
            for(const campo of this.camposFormulario) {
                if(campo.tipo === 'clave') {
                    payload[campo.nombre] = this.companiaDetalle[campo.nombre];
                }
            }
            payload.fecha_unix_actualizacion_clave = Math.floor(Date.now() / 1000);

            await api.put(`/companias/${this.companiaSeleccionadaId}`, payload);
            this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Clave actualizada', life: 3000 });
            this.modalVisible = false;
        },

        toggleVerClave(nombreCampo) {
            this.clavesVisibles[nombreCampo] = !this.clavesVisibles[nombreCampo];
        }
    },
    computed: {
        columnasConAccion() {
            return this.columnas.map(col => {
                if(col.field === 'nombre') {
                    return {
                        ...col,
                        acciones: [{
                            link: true,
                            tipo: 'default',
                            nombreId: 'id',
                            accion: (id) => this.abrirModalCompania(id)
                        }]
                    };
                }
                return col;
            })
        },
        //Campos a mostrar en el formulario (solo 'WEB' y 'WS') y normaliza la etiqueta visible
        camposFormulario() {
            const sistema = this.sistemasPorNombre[this.companiaDetalle?.sistema_compannia];
            const camposPorCategoria = sistema?.configuracion?.campos || {};
            const categoriasPermitidas = ['WEB', 'WS'];
            let resultado = [];

            for(const [categoria, campos] of Object.entries(camposPorCategoria)) {
                if(!categoriasPermitidas.includes(categoria)) continue;

                for (const [nombreCampo, meta] of Object.entries(campos)) {
                    const etiquetaLower = (meta.etiqueta || '').toLowerCase();
                    let tipo;
                    if (etiquetaLower.startsWith('usuario')) tipo = 'usuario';
                    else if (etiquetaLower.startsWith('clave')) tipo = 'clave';
                    else continue;

                    let etiquetaFinal = meta.etiqueta;
                    if (tipo === 'usuario') etiquetaFinal = `Usuario ${categoria}`;
                    else if (tipo === 'clave') etiquetaFinal = `Clave ${categoria}`;

                    resultado.push({
                        nombre: nombreCampo,
                        etiqueta: etiquetaFinal,
                        descripcion: meta.descripcion,
                        tipo
                    })
                }
            }
            return resultado;
        },
        fechaActualizacionFormateada() {
            const unix = this.companiaDetalle?.fecha_unix_actualizacion_clave;
            if(!unix) return 'Sin datos';

            const milisegundos = unix * 1000;
            return new Date(milisegundos).toLocaleString("es-ES", {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        estadoConexionClass() {
            if (this.estadoConexion === 'ok') return 'text-success';
                if (this.estadoConexion === 'error') return 'text-danger';
                return 'text-muted';
        },

        estadoConexionTexto() {
                if (this.estadoConexion === 'ok') return 'Conectado';
                if (this.estadoConexion === 'error') return 'Error de conexión';
                return 'Sin verificar';
        },

        tieneClaveWeb() {
            return this.companiaDetalle?.tipo_sistema?.includes('WEB') ?? false;
        },
        tieneClaveWs() {
            return this.companiaDetalle?.tipo_sistema?.includes('WS') ?? false;
        }
    },
    watch: {
        visiblegestorclaves() {
            this.visiblesidegestorclaves = true;
        },
        modalVisible(nuevoValor) { 
            if(!nuevoValor) {
                this.clavesVisibles = {};
            }
        }
    }
}
</script>
<style scoped>
/* Clase para evitar autocomplete (sugerencia de contraseñas) del navegador */
.fake-password {
    -webkit-text-security: disc;
    text-security: disc; 
}
</style>